import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { GadgetApiService } from '@signature-it/ngx-generic/services';

declare let _: any;

@Component({
    selector: 'multiple-bars-gadget',
    templateUrl: './multiple-bars.gadget.html',
    styleUrls: ['./multiple-bars.gadget.scss'],
    standalone: false
})

export class MultipleBarsGadget implements OnChanges  {

    @Input() title: string;
    @Input() dataCount: number;
    @Input() data;
    percent: number = 0;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (_.has(changes, 'data.currentValue')) {
            if (_.has(changes.data.currentValue, 'statistics_info.statistics')) {
                this.data['statistics_info'].statistics = _.keyBy(changes.data.currentValue.statistics_info.statistics, 'val');
            }
        }
    }

    setStyle(index) {
        let calc = this.data.statistics_info.statistics[index+1].count/this.dataCount*100;
        calc = (calc < 8) ? 8 : calc;
        return {width: calc + '%' } ;
    }

}
